module.exports = __webpack_public_path__ + "static/media/hot04.3c872268.jpg";